import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl } from 'react-intl';

import { usePageSettings, PageSettingsProvider } from '@ratehub/base-ui';
import {
    LatestBlogPosts,
    LayoutRow,
    LayoutRowColumn,
} from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateCorporateBlockMap';
import BlogSharedMessages from '../definitions/BlogSharedMessages';
import isBodyBlock from '../functions/isBodyBlock';
import Layout from './Layout';
import BlockRenderer from './BlockRenderer';


function BlogHomePage({
    blocks = [],
    initialPosts,
}) {
    const intl = useIntl();
    const pageSettings = usePageSettings();

    return (
        <PageSettingsProvider
            value={pageSettings}
        >
            <Layout
                blocks={blocks}
                blockMap={BLOCK_MAP}
            >
                <BlockRenderer
                    blocks={blocks.filter(isBodyBlock)}
                    blockMap={BLOCK_MAP}
                />

                <LayoutRow
                    className="rh-layout-default rh-pt-0 rh-pb-4"
                    includeContentPadding={false}
                >
                    <LayoutRowColumn>
                        <LatestBlogPosts
                            initialPosts={initialPosts}
                            heading={{
                                title: intl.formatMessage(BlogSharedMessages.latestPostsTitle),
                            }}
                        />
                    </LayoutRowColumn>
                </LayoutRow>
            </Layout>
        </PageSettingsProvider>
    );
}

BlogHomePage.propTypes = {
    blocks: PropTypes.array.isRequired,
    initialPosts: PropTypes.array.isRequired,
};

export default BlogHomePage;
